<script setup lang="ts">
import { computed } from "vue";
import type { Mode } from "@/types/control";
import { Badge } from "@/components/ui/badge";

const props = defineProps<{ mode: Mode | null }>();

const label = computed(() => {
  switch (props.mode) {
    case "normal":
      return "Normal";
    case "monitor_only":
      return "Monitor only";
    case "frozen":
      return "Frozen";
    default:
      return "Unknown";
  }
});

const variant = computed(() => {
  switch (props.mode) {
    case "normal":
      return "ok" as const;
    case "monitor_only":
      return "warning" as const;
    case "frozen":
      return "error" as const;
    default:
      return "neutral" as const;
  }
});
</script>

<template>
  <Badge :variant="variant">{{ label }}</Badge>
</template>
